module.exports = __webpack_public_path__ + "static/media/error.ee12b4c8.png";